import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class ScansScanProductVerifiedReportsRoute extends Route {
  model() {
    return this.modelFor('scans.scan.product');
  }
}

export default instrumentRoutePerformance(ScansScanProductVerifiedReportsRoute);
